import { apiToken, calculatePricingUrl, creditPurchaseUrl, validatePromoWithPurchaseUrl } from "../config";

export const calculatePricingWithMinutes = async (data) => {
    try {
        const response = await fetch(calculatePricingUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            },
            body: JSON.stringify(data)
        });
           const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || `HTTP error! status: ${response.status}`);
        }
     
        return res;
    } catch (e) {
        console.error("Error calculating pricing:", e);
        throw e; // Re-throw the error for further handling
    }
}

export const validatePromoWithPurchase = async (data) => {
    try {
        const response = await fetch(validatePromoWithPurchaseUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            },
            body: JSON.stringify(data)
        });
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || `HTTP error! status: ${response.status}`);
        }
        return res;
    } catch (e) {
        console.error("Error validating promo with purchase:", e);
        throw e; // Re-throw the error for further handling
    }
}